export const enum ALGOLIA_EVENT_NAME {
  productClicked = 'Product Clicked',
  productConverted = 'Product Converted',
  productAddedToCart = 'Product Added to Cart',
  productPurchased = 'Product Purchased',
}
